import { render, staticRenderFns } from "./ProjectSetting.vue?vue&type=template&id=1d6a6a9f"
import script from "./ProjectSetting.vue?vue&type=script&lang=js"
export * from "./ProjectSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports